import React from "react";
import { SITE, MENU_CATEGORIES } from "../content";
import { Breadcrumbs } from "../components/Layout";
import { Reveal } from "../components/Motion";
import { SteamBowlIcon } from "../components/Art";

export default function MenuPage() {
  return (
    <>
      <section className="page-head" data-testid="menu-head">
        <Breadcrumbs current="Menu" />
        <h1 className="page-head__title">Menu Kedai</h1>
        <p className="page-head__lede">
          Bakmi, bihun, kwetiaw, nasi, dan gorengan gaya Tionghoa-Indonesia — dimasak saat dipesan.
          Seluruh menu non-halal (mengandung babi).
        </p>
        <SteamBowlIcon className="page-head__icon" />
      </section>
      <section className="section">
        <div className="menu-sheet">
          {MENU_CATEGORIES.map((cat, ci) => (
            <Reveal key={cat.no} className="menu-cat" delay={ci * 0.04}>
              <div className="menu-cat__head">
                <span className="menu-cat__no">{cat.no}</span>
                <h2 className="menu-cat__title">{cat.title}</h2>
                <span className="menu-cat__note">{cat.note}</span>
              </div>
              <div>
                {cat.items.map((item, ii) => (
                  <div className="menu-item" key={item.name} data-testid={`menu-item-${cat.no}-${ii}`}>
                    <span className="menu-item__name">{item.name}</span>
                    <span className="menu-item__desc">{item.desc}</span>
                  </div>
                ))}
              </div>
            </Reveal>
          ))}
          <div className="menu-note" data-testid="menu-price-note">
            <p>
              Harga tidak kami cantumkan di situs ini karena dapat berubah sewaktu-waktu. Silakan
              tanyakan langsung di kedai atau melalui telepon.
            </p>
            <a href={SITE.phoneHref} className="btn btn--seal" data-testid="menu-cta-telepon">
              Telepon {SITE.phoneDisplay}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
